import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=6ccc270b&scoped=true&"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLoginButton.vue?vue&type=style&index=0&id=6ccc270b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc270b",
  null
  
)

export default component.exports